import { BUSINESS_ID_FAILURE, BUSINESS_ID_REQUEST, BUSINESS_ID_SUCCESS, BUSINESS_ID_RESET } from '../actions/business'

export function business(
  state = {
    isFetching: false,
    business: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case BUSINESS_ID_REQUEST:
      return { ...state, isFetching: true, business: null, errorMessage: null }
    case BUSINESS_ID_SUCCESS:
      return { ...state, isFetching: false, business: action.response, errorMessage: null }
    case BUSINESS_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    case BUSINESS_ID_RESET:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
      }
    default:
      return state
  }
}
